import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UserInactiveService } from '../services/user-inactive.service';

@Injectable()
export class UserStatusInterceptor implements HttpInterceptor {
  
  constructor(
    private router: Router,
    private userInactiveService: UserInactiveService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403 && 
            error.error && 
            'error_type' in error.error && 
            error.error.error_type === 'user-inactive') {
          this.userInactiveService.setRedirectedByInterceptor();
          this.router.navigate(['/user-inactive']);
          return throwError(() => error);
        }
        return throwError(() => error);
      })
    );
  }
}
